import { render, staticRenderFns } from "./full-accordion.vue?vue&type=template&id=55354a78&"
import script from "./full-accordion.vue?vue&type=script&lang=js&"
export * from "./full-accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports